import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { NavigationHeader } from "@/components/NavigationHeader";
import { SimpleHero } from "@/components/SimpleHero";
import { ProductsSection } from "@/components/ProductsSection";
import { EnquiryForm } from "@/components/EnquiryForm";
import { ContactStrip } from "@/components/ContactStrip";
import { CompanyDetails } from "@/components/CompanyDetails";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.25,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);

    const anchors = document.querySelectorAll('a[href^="#"]');
    const onClick = (e) => {
      const href = e.currentTarget.getAttribute("href");
      const target = href && document.querySelector(href);
      if (target) {
        e.preventDefault();
        lenis.scrollTo(target, { offset: -72 });
      }
    };
    anchors.forEach((a) => a.addEventListener("click", onClick));

    return () => {
      cancelAnimationFrame(frame);
      anchors.forEach((a) => a.removeEventListener("click", onClick));
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageProvider>
      <div className="bg-white text-[#12261A] min-h-screen" data-testid="app-root">
        <div className="grain-overlay" aria-hidden="true" />
        <NavigationHeader />
        <main>
          <SimpleHero />
          <ProductsSection />
          <EnquiryForm />
          <ContactStrip />
          <CompanyDetails />
        </main>
        <Footer />
        <WhatsAppButton />
        <Toaster theme="light" position="bottom-right" />
      </div>
    </LanguageProvider>
  );
}

export default App;
